import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getMarkingStudentDataForLearningGrowthRange as getMarkingStudentDataForLearningGrowthRangeService,
} from "../../services/maestro/maestro.service";
import { useCallback } from "react";
import { handlerErrorV2 } from "../../utils/errors";
import { toggleLoadingLearningGrowth, updateLearningGrowth } from "../../store/actions/class-marking.actions";

const useLearningGrowth = () => {
  const { classId, ulId, curriculumId } = useParams();
  const currentCurriculum = useSelector(
    (state) => state?.assessment?.currentCurriculum || {}
  );
  const formData = useSelector((state) => state?.class?.unitOfLearning);
  const dispatch = useDispatch();
  const updateStudentLearningGrowth = useCallback(
    async (student, typeMarking, filter) => {
      if (!['completedStudent', 'completedTeacher'].includes(typeMarking)) {
        dispatch(updateLearningGrowth([]));
        return;
      }
      try {
        dispatch(toggleLoadingLearningGrowth(true));
        const query = {
          lcIds: formData?.lcs?.map((lc) => lc._id),
          // lcIds: ["60b06751f16ab087c7c99870"],
          // lcIds: [ "67c7a546cfc5945cf7ec0f1a"],
          // lcIds: ["60b84fd1f16ab087c7c99881"],
          // lcIds: ["60b8509bf16ab087c7c99885"],


          ulId: formData?.status === "active" ? ulId : 'main',
          startDate: formData?.startDate,
          endDate: formData?.endDate,
          typeMarking,
        };

        const response = await getMarkingStudentDataForLearningGrowthRangeService(
          curriculumId,
          student._id,
          query
        );
        if (response.error) {
          return { error: true, message: response.message };
        }
        dispatch(updateLearningGrowth(response.data));
        return { error: false, data: response.data };
      } catch (error) {
        const message = handlerErrorV2(error);
        return { error: true, message };
      } finally {
        dispatch(toggleLoadingLearningGrowth(false));
      }

    }, [classId, curriculumId, ulId, currentCurriculum]);

  return {
    updateStudentLearningGrowth
  };
};

export default useLearningGrowth;
